import React, { Component, ReactElement, ReactNode } from 'react';

interface ContactUsContainerProps {
    children: ReactNode;
}

interface ContactUsContainerState {
    isSubmitted: boolean;
}

interface ContactUsFormChildProps {
    isSubmitted: boolean;
    onNavigateBack: (isSubmitted: boolean) => void;
}

export class ContactUsContainer extends Component<ContactUsContainerProps, ContactUsContainerState> {
    constructor(props: ContactUsContainerProps) {
        super(props);
        this.state = {
            isSubmitted: false
        };
    }

    renderChildren(children: ReactNode) {
        return React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) {
                return child;
            }
            return React.cloneElement<Partial<ContactUsFormChildProps>>(child as ReactElement<Partial<ContactUsFormChildProps>>, {
                isSubmitted: this.state.isSubmitted,
                onNavigateBack: (isSubmitted: boolean) => this.setState({
                    isSubmitted
                })
            });
        });
    }

    render() {
        return (
            <>
                {
                    this.renderChildren(this.props.children)
                }
            </>
        );
    }
}